import get from "lodash/get";
import React, { useState, useEffect, Suspense, lazy } from "react";
import canUseDOM from "../../../../utils/can-use-dom";
import { connect } from "react-redux";
import { isEmpty } from "../../../utils";
import PropTypes from "prop-types";

function MetypeBase(props) {
  const {
    "publisher-name": publisherName,
    "pagebuilder-config": pbConfig,
    "theme-attributes": themeAttributes
  } = props.config;

  const metypeConfig = get(pbConfig, ["general", "meType"], get(themeAttributes, ["metype-config"], {}));
  if (isEmpty(metypeConfig)) return null;
  const [feedWidget, setFeedWidget] = useState(null);
  useEffect(() => {
    async function loadFeed() {
      const Feed = await lazy(() => import(/* webpackChunkName: "metypeFeedWidget" */ "./metype-feedwidget"));
      setFeedWidget(
        <Feed
          host={metypeConfig.host}
          accountId={parseInt(metypeConfig.accountId)}
          publisher={publisherName}
          primaryColor={metypeConfig.primaryColor}
          className={metypeConfig.className || ""}
          secondaryColor={metypeConfig.bgColor}
          fontColor={metypeConfig.fontColor}
        />
      );
    }
    loadFeed();
  }, []);
  return canUseDOM ? <Suspense fallback="">{feedWidget}</Suspense> : null;
}

MetypeBase.propTypes = {
  config: PropTypes.shape({
    "theme-attributes": PropTypes.object,
    "pagebuilder-config": PropTypes.object,
    "publisher-name": PropTypes.string
  })
};

function mapStateToProps(state) {
  return {
    config: state.qt.config || {}
  };
}

const Metype = connect(
  mapStateToProps,
  {}
)(MetypeBase);

export { Metype };
